// extracted by mini-css-extract-plugin
export default {"contents-box-blue":"ContentsBox_contents-box-blue__nVKPT","contents-box-inner":"ContentsBox_contents-box-inner__y1XEG"};